import { render, staticRenderFns } from "./student-reports.vue?vue&type=template&id=d0223b24&"
import script from "./student-reports.vue?vue&type=script&lang=js&"
export * from "./student-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports